var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerServiceHelpSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC91B"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA22F"
    },
    d: "M149.118,371.995l138.107,138.107c115.509-14.048,207.27-105.015,222.53-220.144L380.983,161.185 L149.118,371.995z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#273B7A"
    },
    cx: 256,
    cy: 256,
    r: 157.737
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M255.998,98.263c-0.384,0-0.765,0.012-1.148,0.014v315.445c0.383,0.002,0.764,0.014,1.148,0.014 c87.116,0,157.737-70.622,157.737-157.737S343.114,98.263,255.998,98.263z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#386895"
    },
    cx: 256,
    cy: 256,
    r: 124.983
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#273B7A"
    },
    d: "M255.998,131.017c-0.384,0-0.764,0.026-1.148,0.029v249.908c0.384,0.003,0.764,0.029,1.148,0.029 c69.027,0,124.983-55.956,124.983-124.983S325.025,131.017,255.998,131.017z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.012,263.671l-16.872-16.872c-2.02-2.02-5.292-2.02-7.313,0l-16.874,16.872 c-2.02,2.019-2.02,5.292,0,7.313s5.292,2.02,7.313,0l7.62-7.62c-3.674,32.766-31.535,58.327-65.267,58.327 c-36.223,0-65.691-29.47-65.691-65.691s29.47-65.691,65.691-65.691c2.857,0,5.172-2.315,5.172-5.172 c0-2.857-2.315-5.172-5.172-5.172c-41.925,0-76.035,34.109-76.035,76.035s34.109,76.035,76.035,76.035 c39.689,0,72.352-30.573,75.726-69.403l8.352,8.352c1.01,1.01,2.334,1.515,3.656,1.515s2.646-0.505,3.656-1.515 C351.032,268.965,351.032,265.69,349.012,263.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M257.619,190.309c2.857,0,5.172-2.315,5.172-5.172c0-2.857-2.315-5.172-5.172-5.172 c-0.929,0-1.848,0.036-2.769,0.071v10.343C255.771,190.34,256.691,190.309,257.619,190.309z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M349.012,263.671l-16.872-16.872c-2.02-2.02-5.292-2.02-7.313,0l-16.874,16.872 c-2.02,2.019-2.02,5.292,0,7.313s5.292,2.02,7.313,0l7.62-7.62c-3.674,32.766-31.535,58.327-65.267,58.327 c-0.929,0-1.85-0.033-2.769-0.071v10.343c0.921,0.033,1.839,0.071,2.769,0.071c39.689,0,72.352-30.573,75.726-69.403l8.352,8.352 c1.01,1.01,2.334,1.515,3.656,1.515s2.646-0.505,3.656-1.515C351.032,268.965,351.032,265.69,349.012,263.671z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,154.29c-2.857,0-5.172-2.315-5.172-5.172v-13.791c0-2.857,2.315-5.172,5.172-5.172 s5.172,2.315,5.172,5.172v13.791C261.172,151.974,258.857,154.29,256,154.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,381.845c-2.857,0-5.172-2.315-5.172-5.172v-13.791c0-2.857,2.315-5.172,5.172-5.172 s5.172,2.315,5.172,5.172v13.791C261.172,379.53,258.857,381.845,256,381.845z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M256,130.155c-0.396,0-0.777,0.053-1.148,0.138v23.859c0.371,0.084,0.753,0.138,1.148,0.138 c2.857,0,5.172-2.315,5.172-5.172v-13.791C261.172,132.47,258.857,130.155,256,130.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M256,357.71c-0.396,0-0.777,0.053-1.148,0.138v23.859c0.371,0.084,0.753,0.138,1.148,0.138 c2.857,0,5.172-2.315,5.172-5.172v-13.791C261.172,360.026,258.857,357.71,256,357.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M376.673,261.172h-13.791c-2.857,0-5.172-2.315-5.172-5.172s2.315-5.172,5.172-5.172h13.791 c2.857,0,5.172,2.315,5.172,5.172S379.53,261.172,376.673,261.172z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.118,261.172h-13.791c-2.857,0-5.172-2.315-5.172-5.172s2.315-5.172,5.172-5.172h13.791 c2.857,0,5.172,2.315,5.172,5.172S151.974,261.172,149.118,261.172z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerServiceHelpSvgrepoCom);
export default __webpack_public_path__ + "static/media/customer-service-help-svgrepo-com.abfe51e7f8d2eaf53e6c46abcdca1a93.svg";
export { ForwardRef as ReactComponent };